"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skins = exports.directions = void 0;
var directions = {
  horizontal: 'horizontal',
  vertical: 'vertical'
};
exports.directions = directions;
var skins = {
  light: 'light',
  dark: 'dark',
  standard: 'standard',
  warning: 'warning',
  destructive: 'destructive',
  success: 'success',
  premium: 'premium'
};
exports.skins = skins;